function mapNoteSearchObject(hit) {
  return {
    id: hit.objectID,
    isArchived: false,
    isTemplate: false,
    ...hit,
  }
}

function mapChannelSearchObject(hit) {
  return {
    id: hit.objectID,
    ...hit,
  }
}

export default function searchOnAlgolia({ client, query, organization }) {
  return new Promise((resolve, reject) =>
    client.search(
      [
        {
          indexName: 'notes',
          query,
          params: {
            analyticsTags: [`organization-${organization.id}`],
            hitsPerPage: 20,
            restrictSearchableAttributes: ['title', 'fullPath'],
            filters: 'isArchived:false AND isTemplate:false',
            highlightPreTag: '<span class="font-weight-bold">',
            highlightPostTag: '</span>',
            attributesToSnippet: ['title', 'fullPath:5'],
            snippetEllipsisText: '&hellip;',
            attributesToRetrieve: [
              'title',
              'channelId',
              'channelName',
              'fullPath',
              'objectID',
              'iconShape',
              'iconColor',
              'hasChildren',
            ],
          },
        },
        {
          indexName: 'channels',
          query,
          params: {
            hitsPerPage: 10,
            restrictSearchableAttributes: ['name'],
            analyticsTags: [`organization-${organization.id}`],
          },
        },
      ].filter(x => x),
      (err, { results }) => {
        if (err) {
          return reject(err)
        }
        const [notesResults, channelsResults] = results
        return resolve({
          notes: notesResults.hits.map(mapNoteSearchObject),
          channels: channelsResults.hits.map(mapChannelSearchObject),
        })
      }
    )
  )
}
